// Opt-in local storage for development/QA. Production always uses S3.
// Image display must use the same local origin when this mode is enabled.
export const getPageRenderSaveEndpoint = (
  storage = process.env.REACT_APP_RENDER_STORAGE,
  environment = process.env.NODE_ENV,
) => environment !== 'production' && storage === 'local'
  ? '/api/save_canvas_image'
  : '/api/v2/save_canvas_image';
